import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Icon, Profile, ErrorBoundary } from 'components'
import { setPlanProp, setGoalProp, setGlobalSetting } from 'store/actions'

function EditProfile(props) {
  return (
    <section className="edit-profile">
      <ErrorBoundary>
        <div>
          <h5>EDIT PROFILE</h5>
          <Link to="/"><Icon name="cancel-black" small/></Link>
        </div>
        <div className="form">
          <Profile {...props} />
        </div>
      </ErrorBoundary>
    </section>
  )
}

export default connect(
  state => ({
    profile: state.profile,
    goals: Object.values(state.goals),
    assetClassReturns: state.globalSettings.assetClassReturns
  }),
  { setPlanProp, setGoalProp, setGlobalSetting }
)(EditProfile)


// WEBPACK FOOTER //
// ./src/components/layout/EditProfile.js